module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box box-info"
  }, [_c('DataTable', {
    ref: "po",
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.salesUnreceivedLists,
      "paginator": true,
      "rows": 100,
      "filters": _vm.filters,
      "editMode": "cell",
      "rowsPerPageOptions": [100, 500, 1000],
      "data-key": "id",
      "selection": _vm.selectedProduct1,
      "selectionMode": "single"
    },
    on: {
      "update:selection": function($event) {
        _vm.selectedProduct1 = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_vm._v("No record found")]
      },
      proxy: true
    }])
  }, [_c('Column', {
    attrs: {
      "header": "S.N"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(sl) {
        return [_vm._v("\n                " + _vm._s(sl.index + 1) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Miti",
      "headerStyle": "width:8em;",
      "sortable": true,
      "field": "purchaseSalesDateNepali",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['purchaseSalesDateNepali']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'purchaseSalesDateNepali', $$v)
            },
            expression: "filters['purchaseSalesDateNepali']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Date",
      "headerStyle": "width:8em;",
      "sortable": true,
      "field": "purchaseSalesDate",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['purchaseSalesDate']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'purchaseSalesDate', $$v)
            },
            expression: "filters['purchaseSalesDate']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Bill No",
      "sortable": true,
      "field": "billNo",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['billNo']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'billNo', $$v)
            },
            expression: "filters['billNo']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Customer",
      "sortable": true,
      "field": "accountName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n                " + _vm._s(slotProps.data.accountMaster.name) + "\n              ")]
      }
    }, {
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['accountName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'accountName', $$v)
            },
            expression: "filters['accountName']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                Total:\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Address",
      "sortable": true,
      "field": "address",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['address']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'address', $$v)
            },
            expression: "filters['address']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Contact No",
      "sortable": true,
      "field": "contactNumber",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['contactNumber']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'contactNumber', $$v)
            },
            expression: "filters['contactNumber']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Remarks"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('View Remarks'),
            expression: "'View Remarks'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised p-button-warning",
          on: {
            "click": function($event) {
              return _vm.showMessageDialog(slotProps.data)
            }
          }
        }, [_c('span', {
          staticClass: "pi pi-envelope"
        })])]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Transportation Details"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('View Transport Details'),
            expression: "'View Transport Details'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised p-button-warning",
          on: {
            "click": function($event) {
              return _vm.showTransportationDialog(slotProps.data)
            }
          }
        }, [_c('span', {
          staticClass: "fa fa-truck"
        })])]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Store",
      "sortable": true,
      "field": "warehouse.name",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['warehouse.name']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'warehouse.name', $$v)
            },
            expression: "filters['warehouse.name']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Total",
      "bodyStyle": "text-align: right",
      "field": "totalBillAmount",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['totalBillAmount']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'totalBillAmount', $$v)
            },
            expression: "filters['totalBillAmount']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalSumBillAmount.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Received Status",
      "bodyStyle": "text-align: right",
      "field": "goodsReceivedStatus",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['goodsReceivedStatus']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'goodsReceivedStatus', $$v)
            },
            expression: "filters['goodsReceivedStatus']"
          }
        })]
      },
      proxy: true
    }, {
      key: "editor",
      fn: function(slotProps) {
        return [_c('Dropdown', {
          attrs: {
            "options": _vm.statusesPay,
            "optionLabel": "label",
            "optionValue": "value",
            "placeholder": "Select a Status"
          },
          on: {
            "change": function($event) {
              return _vm.updatePaymentStatus(slotProps.data, 'drop')
            }
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function(slotProps) {
              return [_c('span', [_vm._v(_vm._s(slotProps.option.label))])]
            }
          }], null, true),
          model: {
            value: (slotProps.data['goodsReceivedStatus']),
            callback: function($$v) {
              _vm.$set(slotProps.data, 'goodsReceivedStatus', $$v)
            },
            expression: "slotProps.data['goodsReceivedStatus']"
          }
        })]
      }
    }, {
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n              " + _vm._s(_vm.getReceivedStatusLabel(slotProps.data.goodsReceivedStatus)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Org Name",
      "sortable": true,
      "field": "organisationName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['organisationName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'organisationName', $$v)
            },
            expression: "filters['organisationName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('View Details'),
            expression: "'View Details'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised p-button-warning",
          on: {
            "click": function($event) {
              return _vm.viewPIVDetail(slotProps.data)
            }
          }
        }, [_c('span', {
          staticClass: "fa fa-eye"
        })])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('Dialogs', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Remarks",
      "visible": _vm.receivedMessageDialog,
      "modal": true,
      "closable": true,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.receivedMessageDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "label": "Update"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.updatePaymentStatus(null, 'ramarks')
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": _vm.cancelMessage
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "reason"
    }
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.receivedMessgae),
      expression: "receivedMessgae"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.receivedMessgae)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.receivedMessgae = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticStyle: {
      "color": "#e74c3c",
      "font-style": "italic",
      "display": "block",
      "margin-top": "4px"
    }
  }, [_vm._v("\n            For date in remarks, enter in format like "), _c('strong', [_vm._v("2082-04-29")]), _vm._v(", not 2082/04/29\n          ")])])])]), _vm._v(" "), _c('Dialogs', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Transportation Details",
      "visible": _vm.transportationDialog,
      "modal": true,
      "closable": true,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.transportationDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Close"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.closelTransportation.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "subHead"
    }
  }, [_vm._v("Name"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "subHead"
    },
    model: {
      value: (this.transportationDetails.name),
      callback: function($$v) {
        _vm.$set(this.transportationDetails, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "this.transportationDetails.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "costing"
    }
  }, [_vm._v("Route")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "subHead"
    },
    model: {
      value: (this.transportationDetails.route),
      callback: function($$v) {
        _vm.$set(this.transportationDetails, "route", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "this.transportationDetails.route"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "costing"
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "subHead"
    },
    model: {
      value: (this.transportationDetails.address),
      callback: function($$v) {
        _vm.$set(this.transportationDetails, "address", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "this.transportationDetails.address"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "vat"
    }
  }, [_vm._v("Contact Name")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "subHead"
    },
    model: {
      value: (this.transportationDetails.contactPerson),
      callback: function($$v) {
        _vm.$set(this.transportationDetails, "contactPerson", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "this.transportationDetails.contactPerson"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "head"
    }
  }, [_vm._v("From Contact Number "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "subHead"
    },
    model: {
      value: (this.transportationDetails.contactNumberFrom),
      callback: function($$v) {
        _vm.$set(this.transportationDetails, "contactNumberFrom", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "this.transportationDetails.contactNumberFrom"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "head"
    }
  }, [_vm._v("To Contact Number")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (this.transportationDetails.contactNumberTo),
      expression: "this.transportationDetails.contactNumberTo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "2"
    },
    domProps: {
      "value": (this.transportationDetails.contactNumberTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(this.transportationDetails, "contactNumberTo", $event.target.value)
      }
    }
  })])])])], 1), _vm._v(" "), _c('Dialog', {
    on: {
      "cancel": _vm.cancel,
      "deleted": _vm.deleteReport
    },
    model: {
      value: (_vm.dialogShow),
      callback: function($$v) {
        _vm.dialogShow = $$v
      },
      expression: "dialogShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28ce79b7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/salesReport/salesGoodsUnReceivedReport.vue
// module id = 2104
// module chunks = 0